import { ILookup } from './lookup';

export class BaseComparisonOperatorOptions implements ILookup<string> {
  id: string;
  description: string;

  static greaterThan: BaseComparisonOperatorOptions = { id: '>', description: '>' };
  static lessThan: BaseComparisonOperatorOptions = { id: '<', description: '<' };
  static greaterThanOrEqual: BaseComparisonOperatorOptions = { id: '>=', description: '>=' };
  static lessThanOrEqual: BaseComparisonOperatorOptions = { id: '<=', description: '<=' };
  static equal: BaseComparisonOperatorOptions = { id: '=', description: '=' };
  static notEqual: BaseComparisonOperatorOptions = { id: '<>', description: 'Not Equal' };

  static get options(): ILookup<string>[] {
    return [ 
      BaseComparisonOperatorOptions.greaterThan, 
      BaseComparisonOperatorOptions.lessThan, 
      BaseComparisonOperatorOptions.greaterThanOrEqual, 
      BaseComparisonOperatorOptions.lessThanOrEqual,
      BaseComparisonOperatorOptions.equal,
      BaseComparisonOperatorOptions.notEqual
    ];
  }
}